<div
  *ngIf="returnDetail"
  class="return-detail">
  <div class="return-detail__head">
    <h2 class="headline">{{'RETURN_PAGE.MODAL.TITLE' | translate}}</h2>
    <button
      [cdkCopyToClipboard]="text"
      (cdkCopyToClipboardCopied)="copyDetailEvent($event)"
      class="return-detail__head-copy-btn">
      <img src="assets/img/copy.svg" alt="Copy" class="icon">
    </button>
  </div>
  <div
    #modalBlock
    class="scroll-block">
    <div class="payment-detail__line">
      <div class="info-block">
        <h3 class="info-block__headline">{{'RETURN_PAGE.MODAL.PAYER' | translate}}</h3>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.FULL_NAME' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.full_name}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.PAYER_ID' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.payer_id}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.PAYER_ID_MERCHANT' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.payer_id}}</div>
        </div>
      </div>
      <div class="info-block">
        <h3 class="info-block__headline">{{'RETURN_PAGE.MODAL.RETURN' | translate}}</h3>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.AMOUNT' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.amount}} <span class="currency">{{returnDetail.currency}}</span></div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.ID' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.id}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.PAYMENT_ID' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.payment_id}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.BANK_NAME' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.bank_name}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.BANK_PAYMENT_ID' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.bank_payment_id}}</div>
        </div>
        <div class="info-block__line">
          <div class="info-block__line-left">{{'RETURN_PAGE.MODAL.DATE' | translate}}</div>
          <div class="info-block__line-right">{{returnDetail.date}}</div>
        </div>
      </div>
      <div class="info-block">
        <h3 class="info-block__headline">{{'RETURN_PAGE.MODAL.PAYMENT_PURPOSE' | translate}}</h3>
        <p class="info-block__description">{{returnDetail.payment_purpose}}</p>
      </div>
    </div>
  </div>
</div>
